let apiUrl = "https://api.tedxcusat.in"

export default apiUrl;